/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilitySystemTag
 */
export interface FacilitySystemTag {
    /**
     * 
     * @type {string}
     * @memberof FacilitySystemTag
     */
    category: FacilitySystemTagCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySystemTag
     */
    label: string;
}


/**
 * @export
 */
export const FacilitySystemTagCategoryEnum = {
    UsState: 'US_STATE',
    FacilityType: 'FACILITY_TYPE',
    Region: 'REGION'
} as const;
export type FacilitySystemTagCategoryEnum = typeof FacilitySystemTagCategoryEnum[keyof typeof FacilitySystemTagCategoryEnum];


/**
 * Check if a given object implements the FacilitySystemTag interface.
 */
export function instanceOfFacilitySystemTag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function FacilitySystemTagFromJSON(json: any): FacilitySystemTag {
    return FacilitySystemTagFromJSONTyped(json, false);
}

export function FacilitySystemTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilitySystemTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': json['category'],
        'label': json['label'],
    };
}

export function FacilitySystemTagToJSON(value?: FacilitySystemTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': value.category,
        'label': value.label,
    };
}

